import React, { SVGAttributes } from 'react'

const SvgSearch = (props: SVGAttributes<SVGElement>): JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 13 14" {...props}>
    <path
      fill="#919191"
      fillRule="evenodd"
      d="M5.769 9.831c-2.275 0-4.144-1.787-4.144-4.062a4.161 4.161 0 014.144-4.144 4.161 4.161 0 014.144 4.144c0 2.275-1.87 4.062-4.144 4.062zm4.55-.65a5.563 5.563 0 001.137-3.412C11.456 2.6 8.938 0 5.77 0 2.6 0 0 2.6 0 5.769c0 3.168 2.6 5.769 5.769 5.769 1.3 0 2.519-.407 3.412-1.138l2.438 2.437a.878.878 0 00.569.244.878.878 0 00.568-.244.785.785 0 000-1.137L10.32 9.181z"
    />
  </svg>
)

export default SvgSearch
